import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom'; // Importamos Link
import api from '../services/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Estado de carga
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const res = await api.post('/users/login', { email, password });

      // Guardar token en localStorage
      localStorage.setItem('token', res.data.access_token);

      setMessage('✅ Login exitoso, redirigiendo...');
      setTimeout(() => navigate('/dashboard'), 1000);
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message;

      if (errorMsg.includes('no ha sido confirmada')) {
        setMessage('⚠️ Tu cuenta no está confirmada. Redirigiéndote...');
        setTimeout(() => navigate('/confirm', { state: { email } }), 1500);
      } else if (errorMsg.includes('Credenciales inválidas')) {
        setMessage('❌ Credenciales inválidas. Verifica tu correo y contraseña.');
      } else if (errorMsg.includes('Usuario no encontrado')) {
        setMessage('❌ Usuario no encontrado. Regístrate primero.');
      } else {
        setMessage('❌ Error en login. Intenta nuevamente.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-green-400 to-blue-500 p-4">
      <div className="bg-white shadow-2xl rounded-xl p-8 w-full max-w-md">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Iniciar Sesión
        </h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-semibold mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 focus:outline-none"
              placeholder="ejemplo@correo.com"
              required
            />
          </div>

          <div>
            <div className="flex justify-between mb-1">
              <label className="text-gray-700 font-semibold">Contraseña</label>
              {/* ENLACE DE OLVIDO DE CONTRASEÑA */}
              <Link 
                to="/forgot-password" 
                className="text-sm text-blue-600 hover:underline font-medium"
              >
                ¿Olvidaste tu contraseña?
              </Link>
            </div>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 focus:outline-none"
              placeholder="********"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full py-2 rounded-lg font-semibold transition duration-300 text-white ${
              isLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
            }`}
          >
            {isLoading ? 'Cargando...' : 'Entrar'}
          </button>
        </form>

        {message && (
          <div className={`mt-4 p-3 border rounded-lg text-sm text-center ${
            message.includes('✅') ? 'bg-green-50 border-green-200 text-green-700' : 'bg-red-50 border-red-200 text-red-700'
          }`}>
            {message}
          </div>
        )}

        <p className="text-center text-sm text-gray-600 mt-6">
          ¿No tienes cuenta?{' '}
          <Link to="/register" className="text-green-600 font-bold hover:underline">
            Regístrate
          </Link>
        </p>
      </div>
    </div>
  );
}